import axios from 'axios';
export const createLearningRoute = async (routeApiRoot, token, input) => axios
    .post(`${routeApiRoot}/`, input, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const updateLearningRoute = async (routeApiRoot, token, input) => axios
    .put(`${routeApiRoot}/`, input, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const deleteLearningRoute = async (routeApiRoot, token, input) => axios
    .delete(`${routeApiRoot}/${input.wallet}/${input.id}`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export const getPublicLearningRouteCertificates = async (routeApiRoot, input) => axios
    .get(`${routeApiRoot}/certificate/${input.certificateId}/${input.learningRouteId}`) //
    .then((output) => output.data)
    .catch(async (err) => (err.response?.status === 404 ? undefined : Promise.reject(err)));
export const getLearningRouteDetailsById = async (routeApiRoot, token, input) => axios
    .get(`${routeApiRoot}/${input.wallet}/${input.id}/details`, {
    headers: { authorization: token.value() },
})
    .then((output) => output.data)
    .catch(async (err) => (err.response?.status === 404 ? undefined : Promise.reject(err)));
export const listLearningRoutes = async (routeApiRoot, token, input) => axios
    .get(`${routeApiRoot}`, {
    params: {
        wallet: input.wallet,
    },
    headers: { authorization: token.value() },
})
    .then((output) => output.data);
export var RouteType;
(function (RouteType) {
    RouteType["RANDOM"] = "RANDOM";
    RouteType["SEQUENTIAL"] = "SEQUENTIAL";
})(RouteType || (RouteType = {}));
export const LEARNING_ROUTE_COMPLETED = 'LEARNING_ROUTE_COMPLETED';
//# sourceMappingURL=index.js.map